import React, {useState} from 'react'
import gql from 'graphql-tag'
import {Redirect} from 'react-router-dom'
import {getImageTitle} from 'lib/imageUtils'
import Heading from 'components/shared/Heading'
import Query from 'components/shared/Query'
import SelectablePhotoThumb from 'components/shared/SelectablePhotoThumb'
import PhotoGallery from 'components/shared/PhotoGallery'
import Button from 'components/shared/Button'

const productCorrectionQuery = gql`
  query ProductCorrectionQuery($id: ID!) {
    product(id: $id) {
      id
      name
      state
      createdAt
      ...on PhotoBasedProduct {
        quantity
      }
      ...on AssetsBasedProduct {
        assets {
          edges {
            approved
            node {
              id
              state
              ...on PhotoAsset {
                scope
                image(size: "monitor") {
                  url
                  thumbUrl
                  width
                  height
                  labels
                  filenameIndex
                }
              }
            }
          }
        }
      }
    }
    viewer {
      id
      customer {
        id
        canCreateCorrections
      }
    }
  }
`

const SelectPhotos = ({match, selectedPhotos, stateReducer}) => {
  const [photoPreviewIndex, setPhotoPreviewIndex] = useState(null)

  const previewPhoto = (index) => setPhotoPreviewIndex(index)
  const closeGallery = () => setPhotoPreviewIndex(null)

  const photoIsSelected = (photo) => {
    return !!selectedPhotos.find(p => p.id === photo.id)
  }

  const photoIsSelectable = (photo) => {
    return photo.scope !== 'supplemental' && photo.state !== 'marked_for_correction'
  }

  const getGalleryCaption = (photo) => {
    const getLabel = () => {
      if (photo.state === 'marked_for_correction')
        return 'Allerede valgt'

      if (photo.scope === 'supplemental')
        return 'Kan ikke korrigeres'

      return ''
    }

    return (
      <div className="product-correction-gallery-caption">
        <SelectablePhotoThumb.Overlay
          label={getLabel()}
          selected={photoIsSelected(photo)}
          isSelectable={photoIsSelectable(photo)}
          onChange={(selected) => {
            const type = selected ? 'markPhoto' : 'unmarkPhoto'
            stateReducer({type, photo})
          }}
        />
      </div>
    )
  }

  return (
    <div className="product-correction select-photos">
      <Heading level={2}>Velg bilder til korrigering</Heading>
      <Query
        inlineLoading
        inlineError
        query={productCorrectionQuery}
        variables={{
          id: match.params.productId,
        }}
      >
        {({getData}) => {
          const product = getData('product')
          const viewer = getData('viewer')
          const photos = product.assets.edges.map(e => e.node)

          if (!viewer.customer.canCreateCorrections) {
            const {estateId, productId} = match.params
            return <Redirect to={`/oppdrag/${estateId}/produkt/${productId}`} />
          }

          return (
            <>
              <SelectablePhotoThumb.Wrapper>
                {photos.map((photo, i) => (
                  <SelectablePhotoThumb
                    key={photo.id}
                    photo={photo}
                    selected={photoIsSelected(photo)}
                    title={getImageTitle(photo.image)}
                    onClick={() => previewPhoto(i)}
                    onChange={(selected) => {
                      const type = selected ? 'markPhoto' : 'unmarkPhoto'
                      stateReducer({type, photo})
                    }}
                  />
                ))}
              </SelectablePhotoThumb.Wrapper>

              <div className="actions">
                <Button
                  type="navigation"
                  disabled={selectedPhotos.length === 0}
                  onClick={() => {
                    stateReducer({type: 'setStep', step: 'confirm'})
                  }}
                >
                  Se over valgte bilder ({selectedPhotos.length})
                </Button>
              </div>

              {photoPreviewIndex !== null && (
                <PhotoGallery
                  images={photos.map(p => p.image.url)}
                  initialImageIndex={photoPreviewIndex}
                  onRenderCaption={(index) => getGalleryCaption(photos[index])}
                  onCloseRequest={closeGallery}
                />
              )}
            </>
          )
        }}
      </Query>
    </div>
  )
}

export default SelectPhotos
